export const ORIENTATION_STATUSES = Object.freeze({
    IDLE: 'idle',
    INVITED: 'invited',
    RUNNING: 'running',
    WAITING: 'waiting',
    PAUSED: 'paused',
    DISMISSED: 'dismissed',
    COMPLETED: 'completed',
});

export const INITIAL_ORIENTATION_STATE = Object.freeze({
    status: ORIENTATION_STATUSES.IDLE,
    invitationKind: null,
    currentStepIndex: 0,
    target: null,
    targetState: 'idle',
    waiting: null,
});

export const orientationReducer = (state, action) => {
    switch (action.type) {
        case 'RESET':
            return { ...INITIAL_ORIENTATION_STATE };
        case 'INVITE':
            if (![ORIENTATION_STATUSES.IDLE, ORIENTATION_STATUSES.PAUSED].includes(state.status)) return state;
            return {
                ...state,
                status: ORIENTATION_STATUSES.INVITED,
                invitationKind: action.payload.kind,
                currentStepIndex: action.payload.stepIndex ?? state.currentStepIndex,
            };
        case 'START':
            if (![ORIENTATION_STATUSES.IDLE, ORIENTATION_STATUSES.INVITED, ORIENTATION_STATUSES.PAUSED, ORIENTATION_STATUSES.WAITING, ORIENTATION_STATUSES.DISMISSED, ORIENTATION_STATUSES.COMPLETED].includes(state.status)) return state;
            return {
                ...state,
                status: ORIENTATION_STATUSES.RUNNING,
                invitationKind: null,
                currentStepIndex: action.payload.stepIndex,
                target: null,
                targetState: 'idle',
                waiting: null,
            };
        case 'WAIT':
            if (state.status !== ORIENTATION_STATUSES.RUNNING) return state;
            return {
                ...state,
                status: ORIENTATION_STATUSES.WAITING,
                currentStepIndex: action.payload.stepIndex,
                target: null,
                targetState: 'idle',
                waiting: action.payload.waiting,
            };
        case 'RESTORE_WAITING':
            if (![ORIENTATION_STATUSES.IDLE, ORIENTATION_STATUSES.INVITED, ORIENTATION_STATUSES.PAUSED].includes(state.status)) return state;
            return {
                ...state,
                status: ORIENTATION_STATUSES.WAITING,
                invitationKind: null,
                currentStepIndex: action.payload.stepIndex,
                target: null,
                targetState: 'idle',
                waiting: action.payload.waiting,
            };
        case 'CONTINUE_WAITING':
            if (state.status !== ORIENTATION_STATUSES.WAITING) return state;
            return {
                ...state,
                status: ORIENTATION_STATUSES.RUNNING,
                target: null,
                targetState: 'idle',
                waiting: null,
            };
        case 'SET_STEP':
            if (state.status !== ORIENTATION_STATUSES.RUNNING) return state;
            return {
                ...state,
                currentStepIndex: action.payload.stepIndex,
                target: null,
                targetState: 'idle',
            };
        case 'TARGET_RESOLVING':
            if (state.status !== ORIENTATION_STATUSES.RUNNING) return state;
            return { ...state, target: null, targetState: 'resolving' };
        case 'TARGET_RESOLVED':
            if (state.status !== ORIENTATION_STATUSES.RUNNING) return state;
            return { ...state, target: action.payload.target, targetState: 'resolved' };
        case 'TARGET_MISSING':
            if (state.status !== ORIENTATION_STATUSES.RUNNING) return state;
            return { ...state, target: null, targetState: 'missing' };
        case 'PAUSE':
            if (![ORIENTATION_STATUSES.RUNNING, ORIENTATION_STATUSES.WAITING].includes(state.status)) return state;
            return { ...state, status: ORIENTATION_STATUSES.PAUSED, target: null, targetState: 'idle', waiting: null };
        case 'DISMISS':
            if (![ORIENTATION_STATUSES.INVITED, ORIENTATION_STATUSES.RUNNING, ORIENTATION_STATUSES.WAITING, ORIENTATION_STATUSES.PAUSED].includes(state.status)) return state;
            return { ...state, status: ORIENTATION_STATUSES.DISMISSED, invitationKind: null, target: null, targetState: 'idle', waiting: null };
        case 'COMPLETE':
            if (state.status !== ORIENTATION_STATUSES.RUNNING) return state;
            return { ...state, status: ORIENTATION_STATUSES.COMPLETED, target: null, targetState: 'idle' };
        case 'HIDE_INVITATION':
            if (state.status !== ORIENTATION_STATUSES.INVITED) return state;
            return { ...state, status: ORIENTATION_STATUSES.IDLE, invitationKind: null };
        default:
            return state;
    }
};
